import { FormEvent } from "react";
import {
  DropdownFacetType,
  FacetChangeEvent,
  FacetsType,
  ResourcedTexts,
} from "../SearchFilterResultData";
import { Select } from "../facet/select/Select";

type SearchProps = {
  searchTerm: string;
  facets: FacetsType;
  resourcedTexts: ResourcedTexts;
  onChange: (value: string) => void;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  showSearchBoxSelect: boolean;
  onSearchBoxSelectChange?: FacetChangeEvent;
  loading?: boolean;
};

export function Search({
  searchTerm,
  facets,
  resourcedTexts,
  onChange,
  onSubmit,
  showSearchBoxSelect,
  onSearchBoxSelectChange,
  loading,
}: SearchProps) {
  const searchBoxSelectFacet =
    showSearchBoxSelect &&
    onSearchBoxSelectChange &&
    facets.find(
      (facet): facet is DropdownFacetType => facet.type === "select" && !!facet.displayInSearchBar
    );

  return (
    <section className="search-box">
      <form className="search-box__search" onSubmit={onSubmit}>
        {searchBoxSelectFacet && (
          <Select
            facet={searchBoxSelectFacet}
            onChange={onSearchBoxSelectChange}
            disabled={loading}
          />
        )}
        <label htmlFor="search_input" className="search-box__input">
          <span className="visually-hidden">{resourcedTexts.searchPlaceholder}</span>
          <input
            id="search_input"
            type="text"
            className="search-box__searchinput"
            placeholder={resourcedTexts.searchPlaceholder}
            name="search"
            title={resourcedTexts.searchInputBoxTitle}
            aria-describedby="search"
            value={searchTerm}
            onChange={(e) => onChange(e.target.value)}
            disabled={loading}
          />
        </label>
      </form>
    </section>
  );
}
